import ActionButton from "@components/ActionButton/ActionButton";
import BalanceDisplay from "@components/BalanceDisplay/BalanceDisplay";

// Temporary disable until Solana top up for TON is ready
// import TokenConversionPanel from "@components/TokenConversionPanel/TokenConversionPanel";
import {
    Container,
    HeaderContent,
    AssetLabel,
    Divider,
    ActionButtonsContainer,
    ActionButtonSkeletonContainer,
    ActionButtonSkeletonWrapper,
    ActionButtonsWrapper
} from "./HomeHeader.styles";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import SkeletonLoader from "@components/SkeletonLoader/SkeletonLoader";
import { usePayLinkStore } from "@stores/payLinkStore";
import { useUserRestrictions } from "@hooks/useUserRestrictions";

type Props = {
    balance: number | 'unavailable'
    isBalanceLoading?: boolean
}

const HomeHeader = ({ balance, isBalanceLoading }: Props) => {
    const navigate = useNavigate()
    const { isEnabled: isPayLinkEnabled } = usePayLinkStore()
    const { canUsePpob } = useUserRestrictions()
    const { t } = useTranslation()

    return (
        <Container>
            <HeaderContent>
                <AssetLabel>{t('page.home.header.assetLabel')}</AssetLabel>
                {isBalanceLoading ?
                    <SkeletonLoader
                        width={100}
                        height={24}
                    />
                    :
                    <BalanceDisplay
                        balance={balance}
                    />
                }
                {/* Temporary disable until Solana top up for TON is ready */}
                {/* <TokenConversionPanel /> */}
            </HeaderContent>
            <Divider />
            <ActionButtonsContainer>
                {false ? // Temporary disabled
                    <ActionButtonSkeletonContainer>
                        <ActionButtonSkeleton />
                        <ActionButtonSkeleton />
                        <ActionButtonSkeleton />
                        <ActionButtonSkeleton />
                    </ActionButtonSkeletonContainer>
                    :
                    <ActionButtonsWrapper $onlyTwoButtons={!isPayLinkEnabled && !canUsePpob()}>
                        <ActionButton type="top-up" onClick={() => navigate("/top-up-method")} />
                        <ActionButton type="p2p-transfer" onClick={() => navigate("/transfer")} />
                        {canUsePpob() &&
                            <ActionButton
                                type="ppob"
                                onClick={() => navigate("/payment-point")}
                            />
                        }
                        {isPayLinkEnabled &&
                            <ActionButton
                                type="payment-link"
                                onClick={() => navigate("/payment-link")}
                            />
                        }
                    </ActionButtonsWrapper>
                }
            </ActionButtonsContainer>
        </Container>
    );
}

const ActionButtonSkeleton = () => {
    return (
        <ActionButtonSkeletonWrapper>
            <SkeletonLoader
                width={46}
                height={46}
                borderRadius={100}
            />
            <SkeletonLoader
                width={50}
                height={15}
            />
        </ActionButtonSkeletonWrapper>
    )
}

export default HomeHeader;
